import { COLORS } from '../../../../../utils/colors';

export const useDocEditorPagesStyles = () => {
  return {
    section: {
      margin: '1rem',
      borderRadius: '0.4rem',
      display: 'flex',
      justifyContent: 'center',
      flexDirection: 'column',
      textAlign: 'center',
      alignItems: 'center',
      width: '7rem',
      height: '9rem',
      minWidth: '7rem',
      minHeight: '9rem',
      position: 'relative',
    },
    previewBox: {
      //width: '100%',
      //height: '100%',
      //position: 'relative',
      overflow: 'hidden',
      cursor: 'pointer',

      position: 'absolute',
      inset: 0,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    previewBoxInner: {
      //transformOrigin: 'top left',
      //width: '50rem',
      //height: 'auto',
      //textAlign: 'left',
      //boxSizing: 'border-box',
      //userSelect: 'none',
      //pointerEvents: 'none',
      //fontSize: '5rem',
      textAlign: 'center',
    },
    container: {
      height: 'calc(100vh - 6.5rem)',
      marginTop: '0.5rem',
      padding: '0.8rem',
      alignItems: 'center',
      display: 'flex',
      flexDirection: 'column',
    },
    closeButton: {
      zIndex: 10,
      position: 'absolute',
      top: 0,
      right: 0,
      borderRadius: '1rem',
      background: COLORS.LIGHT_GRAY,
      padding: '0.1rem',
      margin: '0.2rem',
    },
    sectionsContainer: {
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      flexDirection: 'column',
      height: '70vh',
      overflowY: 'auto',
    },
    addSectionButton: {
      borderRadius: '1rem',
      borderColor: COLORS.MEDIUM_GRAY,
      color: COLORS.MEDIUM_GRAY,
      textTransform: 'none',
      mb: '1rem',
    },
    blocksContainer: {
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      flexDirection: 'column',
      marginTop: '1rem',
    },
    blocksIcons: {
      display: 'flex',
      justifyContent: 'space-evenly',
      width: '100%',
    },
    blocksHeader: {
      display: 'flex',
      alignItems: 'center',
      fontSize: '0.7rem',
      marginTop: '1rem',
      fontWeight: 500,
    },
  };
};
